import React from 'react';
import { StyleSheet, View } from 'react-native';
import { theme } from '@garnish/constants';
import { BodyText, Icon } from '@sg/garnish';

import { TooltipWithBanner } from '@order/components';
import { useLocalizationContext } from '@order/Localization';

import { LOCATION_RESULTS_OTHER_LOCATIONS_TITLE_HEIGHT } from '../../LocationResultsV2.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationResultsOtherLocationsTitle = (
  props: LocationResultsOtherLocationsTitleProps,
) => {
  const { otherLocationSearchType } = props;

  const { t } = useLocalizationContext();

  return (
    <View style={styles.container}>
      <BodyText size={2} numberOfLines={1} style={styles.label}>
        {t('location.result.other-locations', {
          locationSearchType: otherLocationSearchType,
        })}
      </BodyText>

      {otherLocationSearchType === 'outpost' ? (
        <TooltipWithBanner label={t('location.result.outpost-hint')}>
          <Icon name="IconHelp" width={20} height={20} />
        </TooltipWithBanner>
      ) : null}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: LOCATION_RESULTS_OTHER_LOCATIONS_TITLE_HEIGHT,
    paddingHorizontal: 12,
  },
  label: {
    textAlign: 'center',
    marginRight: theme.spacing.small,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LocationResultsOtherLocationsTitleProps = {
  readonly otherLocationSearchType: 'pickup' | 'delivery' | 'outpost';
};
